import React, { forwardRef, ReactNode } from 'react';
import classNames from 'classnames';
import { Collapsible } from 'ncoded-component-library';
import ChevrondownIcon from 'icons/Chevrondown.icon';
import {
  CollapsibleProps,
  CollapsibleRef,
} from 'ncoded-component-library/build/components/molecules/Collapsible/Collapsible.component';

import './CollapsibleSection.styles.scss';

type CollapsibleSectionProps = {
  children: ReactNode;
} & CollapsibleProps;

const CollapsibleSection: React.ForwardRefRenderFunction<
  CollapsibleRef,
  CollapsibleSectionProps
> = ({ children, trigger, className, ...rest }, ref) => (
  <Collapsible
    className={classNames('collapsible-section', className)}
    ref={ref}
    trigger={
      <div className="trigger">
        {trigger}
        <div className="trigger__action-buttons">
          <ChevrondownIcon />
        </div>
      </div>
    }
    {...rest}
  >
    {children}
  </Collapsible>
);

export default forwardRef(CollapsibleSection);
